import { Component } from '@theme/component';

class slideshowSlide extends Component {
  connectedCallback() {
    super.connectedCallback();

    this.active = false;
    this.slides = this.closest('slideshow-component')?.querySelectorAll('slideshow-slide') ?? [];


    this.addEventListener('click', this.#onClick.bind(this));
  }

  #onClick = async (e) => {
    const slide = e.target.closest('slideshow-slide');
      if (!slide || slide !== this) return;

      const image = this.querySelector('.deferred-media__poster-button');
      const video = this.querySelector('video');

      this.active = !this.active;
      this.dataset.active = String(this.active);

      if (this.active) {
        this.playVideo(this, image, video);
      } else {
        this.pauseVideo(image, video);
      }
  }

  playVideo(currentSlide, image, video) {

    this.pauseAllVideos(currentSlide);

    if (!video) return;

    setTimeout(() => {
      if (image) {
        image.style.opacity = '0';
        const img = image.querySelector('img');
        if (img) img.style.opacity = '0';
      }
      video.style.opacity = '1';
    }, 150); 

    deferredMedia?.showDeferredMedia()
    video.play();

  }

  pauseVideo(image, video) {
    if (video) {
      video.pause();
      video.style.opacity = '0';
    }

    if (image) {
      image.style.opacity = '1';
      const img = image.querySelector('img');
      if (img) img.style.opacity = '1';
    }
  }

  pauseAllVideos(exceptSlide) {
    const slides = this.closest('slideshow-component')?.querySelectorAll('slideshow-slide') ?? [];

    slides.forEach((slide) => {
      if (slide === exceptSlide) return;

      slide.active = false;
      slide.dataset.active = 'false';

      const video = slide.querySelector('video');
      const image = slide.querySelector('.deferred-media__poster-button');
      slide.pauseVideo?.(image, video);
    });
  }
}

if (!customElements.get('slideshow-slide')) {
  customElements.define('slideshow-slide', slideshowSlide);
}
